
import EmptyContent from "./related-content/EmptyContent";
import RelatedPodcasts from "./related-content/RelatedPodcasts";
import RelatedVideos from "./related-content/RelatedVideos";
import RelatedSummaries from "./related-content/RelatedSummaries";

interface InsightRelatedContentProps {
  relatedContent: any;
  hasRelatedContent: boolean;
}

const InsightRelatedContent = ({ relatedContent, hasRelatedContent }: InsightRelatedContentProps) => {
  if (!hasRelatedContent) {
    return <EmptyContent />;
  }

  return (
    <div>
      <h2 className="text-lg font-semibold text-nation-blue mb-4">
        Educational Content
      </h2>
      
      <RelatedPodcasts podcasts={relatedContent.podcasts} />
      <RelatedVideos videos={relatedContent.videos} />
      <RelatedSummaries summaries={relatedContent.summaries} />
    </div>
  );
};

export default InsightRelatedContent;
